import React from 'react';
import { connect } from 'react-redux';
import { Flex, Box } from '@marvelapp/ui';
import { SpecsValue } from '@marvelapp/ui-internal';
import { rgbaArray2hex, rgbaArray2rgbaCSS, rgbArray2hybridCSS, } from '../../utils/convertColours';
import * as code from '../../constants/code';
import { getCurrentLanguage } from '../../selectors/code';
import { getColorMode } from '../../selectors/handoff';
import * as colorModes from '../../constants/colorModes';
import PanelSwatch from './PanelSwatch';
function PanelSwatchLong(_a) {
    var color = _a.color, wordBreak = _a.wordBreak, colorMode = _a.colorMode;
    var isRGBAModeOn = colorMode === colorModes.RGBA;
    var swatchColor = isRGBAModeOn
        ? rgbaArray2rgbaCSS(color)
        : rgbArray2hybridCSS(color);
    var clipboardText = isRGBAModeOn
        ? rgbaArray2rgbaCSS(color)
        : "#" + rgbaArray2hex(color);
    return (React.createElement(Flex, { alignItems: "center" },
        React.createElement(Box, { height: 16, marginRight: "6px", width: 16 },
            React.createElement(PanelSwatch, { color: color, iconHeight: 16, iconWidth: 16 })),
        React.createElement(SpecsValue, { clipboardText: clipboardText, wordBreak: wordBreak }, swatchColor)));
}
function mapStateToProps(state) {
    var isCurrentLangCSS = getCurrentLanguage(state) === code.CSS;
    return {
        colorMode: isCurrentLangCSS ? getColorMode(state) : colorModes.HEX,
    };
}
export default connect(mapStateToProps)(PanelSwatchLong);
